<template>
	<div>
		<v-layout row>
			<v-flex>
				<v-card style="margin: 10px !important;">
					<v-card-title class="grey darken-3 white--text">
						<h3>Sprawozdanie końcowe {{showApprovedHeader ? ' - zatwierdzone' : ''}}</h3>
					</v-card-title>
					<v-card-text>
						<display-text-component v-if="projectTitle"
							label="Nazwa projektu"
							:value="projectTitle"/>
						<display-text-component v-if="projectCode"
							label="Numer projektu"
							:value="projectCode"/>
						<display-text-component v-if="projectStartDate && projectEndDate"
							label="Okres realizacji projektu"
							:value="projectStartDate + ' - ' + projectEndDate"/>
						<display-text-component v-if="agencyName"
							label="Nazwa placówki"
							:value="agencyName"/>
						<display-text-component v-if="partnerName"
							label="Nazwa instytucji partnerskiej / wykonawcy"
							:value="partnerName"/>
						<display-text-component v-if="ministerDonation"
							label="Przyznana kwota finansowania"
							:value="formatMoneyWithCode(ministerDonation, currency)"/>
						<display-text-component v-if="approvedDonation"
							label="Zatwierdzona kwota finansowania"
							:value="formatMoneyWithCode(approvedDonation, currency)"/>
						<display-text-component v-if="sendDate"
							label="Data wysłania sprawozdania"
							:value="sendDate"/>
						<display-text-component v-if="approvalDate"
							label="Data zatwierdzenia sprawozdania"
							:value="approvalDate"/>
						<display-text-component v-if="controlSum"
							label="Suma kontrolna"
							:value="controlSum"/>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import DisplayTextComponent from "../../offer/components/DisplayTextComponent";
	import {Numbers} from "../../../../utils/Numbers";

	export default {
		name: "AgencyFinalReportHeader",
		components: {DisplayTextComponent},

		mixins: [
			Numbers
		],

		props: {
			projectTitle: {type: String, default: ''},
			projectCode: {type: String, default: ''},
			controlSum: {type: String, default: ''},
			agencyName: {type: String, default: ''},
			partnerName: {type: String, default: ''},
			projectStartDate: {type: String, default: ''},
			projectEndDate: {type: String, default: ''},
      ministerDonation: {type: Number, default: null},
			approvedDonation: {type: Number, default: null},
			sendDate: {type: String, default: ''},
			approvalDate: {type: String, default: ''},
			currency: {type: String, default: ''},
			showApprovedHeader: {type: Boolean, default: false}
		}
	};
</script>

<style scoped>

</style>